export default __webpack_public_path__ + "static/media/gallery-image-9.a0459c7e.jpg";